import {FulltextSearch} from '@/api/meta/filters';
import {FilterDisplayItem, homogenizeFilterFormatter} from '@/store/types';

export function toDisplay(label: string) {
  if (label) {
    label = label + ': ';
  }

  return (val: number | string | undefined | Date) => {
    if (val !== undefined) {
      return label + String(val);
    }
  };
}

export function boolToDisplay(yes: string, no: string, label = ''): (val: boolean | undefined) => FilterDisplayItem | undefined {
  if (label) {
    label = label + ': ';
  }
  return (val: boolean | undefined) => {
    if (val === undefined) return undefined;
    if (val) {
      return {
        text: label + yes,
        color: 'success',
      };
    } else {
      return {
        text: label + no,
        color: 'error',
      };
    }
  };
}

export function JNToDisplay(yes: string, no: string, label = ''): (val: 'J' | 'N' | undefined) => FilterDisplayItem | undefined {
  if (label) {
    label = label + ': ';
  }
  return (val: 'J' | 'N' | undefined) => {
    if (val === undefined) return undefined;
    if (val === 'J') {
      return {
        text: label + yes,
        color: 'error',
      };
    } else {
      return {
        text: label + no,
        color: 'success',
      };
    }
  };
}

type FilterFormatter<Filter> = {[Key in keyof Filter]?:
  ((value: Filter[Key]) => FilterDisplayItem | FilterDisplayItem[] | undefined) }


// Nicht verwendet, weil es nur an einer Stelle nützlich wäre und die Typen damit verrückt werden.
// TODO: Fix or delete
export function nested<Filter>(subformatter: FilterFormatter<Filter>) {
  return (val: Filter | undefined): FilterDisplayItem[] => {
    const result: FilterDisplayItem[] = [];
    for (const key in val) {
      if (!(key in subformatter)) continue;
      // @ts-expect-error
      const temp = homogenizeFilterFormatter(subformatter[key]!(val[key]));
      if (temp !== undefined) {
        result.push(...temp);
      }
    }
    return result;
  };
}

export function fulltextToDisplay(val: FulltextSearch, label = 'Suche: '): FilterDisplayItem | undefined {
  if (val.words.length > 0) {
    return {
      text: label + val.words.join(' '),
      keypath: ['words'],
    };
  }
}
